import React from "react";
import styles from "../styles/CreateChatbot.module.css";

export default function Contacts({ language, collected_emails }) {
  return (
    <div
      style={{
        borderRadius: 12,
        width: "50vw",
        right: 0,
        margin: 20,
        padding: 20,
        height: "100vh",
        fontFamily: "Jost",
        fontWeight: 600,
        scrollbarWidth: "none",
        overflow: "scroll",
        paddingBottom: 40,
      }}
    >
      <h5 className={styles.header} style={{ color: "#000" }}>
        {language === "en"
          ? `Here you will see all the emails and Telegram usernames that the chatbot collects`
          : `Здесь вы сможете увидеть все собранные ботом email и Telegram юзернеймы`}
        <br></br>
      </h5>
      <h5 className={styles.header} style={{ color: "#000" }}>
        {language === "en"
          ? `Collected in total: ${collected_emails.length - 1}`
          : `Всего собрано: ${collected_emails.length - 1}`}
        <br></br>
      </h5>
      {collected_emails.map((email) => {
        return (
          <div key={collected_emails.indexOf(email)}>
            <h3
              className={styles.header}
              style={{
                color: "#000",
                fontSize: 14,
                marginBottom: 3,
                marginTop: 3,
              }}
            >
              {email}
            </h3>
          </div>
        );
      })}
    </div>
  );
}
